import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remix',
  templateUrl: './remix.component.html',
  styleUrls: ['./remix.component.scss']
})

/**
 * Remix component - handling the remix icon with navbar and content
 */
export class RemixComponent implements OnInit {
  // bread crumb items
  breadCrumbItems: Array<any>;

  constructor() { }

  ngOnInit() {
    this.breadCrumbItems = [{ label: 'Aivis', path: '/' }, { label: 'Icons', path: '/' }, { label: 'Remix', path: '/', active: true }];

  }

}
